module.exports = __webpack_public_path__ + "img/03.bd324a22.jpg";